module.exports = __webpack_public_path__ + "static/img/IMG_20160918_152148.39efa951.jpg";